import { render, staticRenderFns } from "./FormItemAnswer.vue?vue&type=template&id=e1434e7e&scoped=true"
import script from "./FormItemAnswer.vue?vue&type=script&lang=js"
export * from "./FormItemAnswer.vue?vue&type=script&lang=js"
import style0 from "./FormItemAnswer.vue?vue&type=style&index=0&id=e1434e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1434e7e",
  null
  
)

export default component.exports